import { useState, useCallback, useRef } from 'react';
import {
  useMeetingSelector,
  useStableEvent
} from '../meeting/meetingProviderContextDef';
import { events } from '../utils';
/**
 *
 * @returns {{
 *  startWhiteboard: () => Promise<void>,
 *  stopWhiteboard: () => Promise<void>,
 *  whiteboardUrl: string | null
 * }}
 */
const useWhiteboard = () => {
  const selectMeeting = useCallback(s => s.meeting, []);
  const meeting = useMeetingSelector(selectMeeting);
  const selectIsMeetingJoined = useCallback(s => s.isMeetingJoined, []);
  const isMeetingJoined = useMeetingSelector(selectIsMeetingJoined);

  const [whiteboardUrl, setWhiteboardUrl] = useState(null);

  const meetingRef = useRef(meeting);
  meetingRef.current = meeting;
  const isMeetingJoinedRef = useRef(isMeetingJoined);
  isMeetingJoinedRef.current = isMeetingJoined;

  useStableEvent(events['whiteboard-started'], data => {
    if (data?.url) setWhiteboardUrl(data.url);
  });
  useStableEvent(events['whiteboard-stopped'], () => setWhiteboardUrl(null));

  const startWhiteboard = useCallback(async () => {
    if (!isMeetingJoinedRef.current || !meetingRef.current) return;
    try {
      await meetingRef.current.startWhiteboard();
    } catch (error) {
      console.error('Error starting whiteboard:', error);
    }
  }, []);

  const stopWhiteboard = useCallback(async () => {
    if (!isMeetingJoinedRef.current || !meetingRef.current) return;
    try {
      await meetingRef.current.stopWhiteboard();
    } catch (error) {
      console.error('Error stopping whiteboard:', error);
    }
  }, []);

  return { whiteboardUrl, startWhiteboard, stopWhiteboard };
};

export default useWhiteboard;
